import React from "react";
import Video from "../../videos/video.mp4";
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  HeroButton,
  HeroSummary,
} from "./HeroElements";

const HeroSection = () => {
  return (
    <HeroContainer>
      <HeroBg>
        <VideoBg autoPlay loop muted playsInline src={Video} type="video/mp4" />
      </HeroBg>

      <HeroContent>
        <HeroH1>Spend less. Produce more.</HeroH1>

        <HeroP>
          Strategic IT services for small professional services teams. Reduce
          overhead, tighten systems, and keep your team moving in the right
          direction.
        </HeroP>

        <HeroBtnWrapper>
          <HeroButton
            href="https://outlook.office.com/bookwithme/user/bb51bbe3bc3d4e3eb0635e8990c6ad0b@shift-it.io?anonymous&ep=plink"
            primary={true}
            dark={true}
          >
            Book a 15-minute Fit Check
          </HeroButton>
        </HeroBtnWrapper>
        <HeroSummary>
          No commitment. Low pressure. A quick conversation to see if we are a
          fit and what a next step could look like.
        </HeroSummary>
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
